import { Grid } from '@mui/material';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { MODULES } from 'common/constants';
import {
	REG_INV_CARD_TYPE,
	REGULATION_TAB_VALUES,
} from 'common/constants/RegulationInventoryConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import storageWrapper from 'common/loginUtils/storage-wrapper';
import { setRequirementInventoryBreadcrumbText } from 'common/store/reducer/commonReducer';
import { setRegInvLandingSelectedTab } from 'common/store/reducer/regulationInventoryReducer';
import { urlWithTenant } from 'common/utils/utilFunctions';

import InventoryCard from 'features/RegulationInventory/Components/InventoryCard/InventoryCard';
import { buildWorkFlowCardDetails } from 'features/RegulationInventory/RegInventoryUtils';

import { setFilters } from '../CurrentInventory/CurrentInventory';

import styles from './BuildWorkFlow.module.scss';

const { BUILD_WORKFLOW } = REGULATION_TAB_VALUES;

const { REQUIREMENT_INVENTORY } = MODULES;

const { WORK_FLOW } = REG_INV_CARD_TYPE;

const { regulationInventory, overView } = rrcpDashboardRoutes;

const BuildWorkFlow = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const cardClickHandler = (title: string) => {
		dispatch(setRegInvLandingSelectedTab(BUILD_WORKFLOW));
		dispatch(setRequirementInventoryBreadcrumbText(REQUIREMENT_INVENTORY));
		setBuildWorkFlowFilter(title);
		storageWrapper.setStorageItem('selectedCardDetails', {
			selectedCardName: title,
			selectedRegInvLandingTab: BUILD_WORKFLOW,
			selectedTab: 0,
		});
		navigate(urlWithTenant(`/${regulationInventory}/${overView}`));
	};

	const setBuildWorkFlowFilter = (value: string) => {
		setFilters(value, dispatch, BUILD_WORKFLOW);
	};

	return (
		<Grid container>
			{buildWorkFlowCardDetails.map((category) => (
				<Grid
					key={category.title}
					item
					xs={12}
					sm={4}
					md={4}
					lg={4}
					xl={4}
					className={styles['card-content']}
					spacing={2}
				>
					<InventoryCard
						key={category.title}
						apiHeaders={category.headers}
						cardType={WORK_FLOW}
						title={category.title}
						handleClick={() => cardClickHandler(category.title)}
					/>
				</Grid>
			))}
		</Grid>
	);
};

export default BuildWorkFlow;
